<div class="sendConversationMessage">
  <!--<image-drag-drop>-->
  <form>

    <div class="row m-0" *ngIf="this.nickVisible">
      <div class="col-md-12 col-sm-12 p-0">
          <mat-form-field class="w-100">
            <input [formControl]="nickname" 
            class="input-sendconve" 
            [style.border]="nickVisible && nick.trim()=='' && !hideRequirement ? '1px solid red' : ''" 
            matInput 
            placeholder="Your nick" required/>
          </mat-form-field>
      </div>
    </div>

    <div class="row m-0 mb-3">

      <div class="col-12 p-0">
        <div class="textbox-container">
          <mat-form-field class="w-100">
          <textarea [formControl]="msg" #message (blur)="contentBlur($event)" matInput
                    [style.border]="conversationMessageContent.trim()=='' && !hideRequirement ? '1px solid red' : ''"
                    class="w-100  min-h-text no-resize p-3"
                    placeholder="Your message" required></textarea>
          </mat-form-field>

        </div>
        <div class="emoji-container">
          <emoji-picker *ngIf="isSpecialUser || PremiumAdvertisementMessages"
                        (change)="updateMessage($event)" [text]="conversationMessageContent"
                        [element]="message"></emoji-picker>
        </div>

      </div>
    </div>
    <div class="row m-0">
      <div class="col-md-12 col-sm-12 p-0">
        <image-attach (setImagesIsUploaded)="setImagesIsUploaded($event)" (maxAttachmentsExceeded)="showMaxAttachmentsExceeded()" maxAttachments="{{(isSpecialUser || PremiumAdvertisementMessages) ? 999 : userMaxImagesLength}}" #attachImage
                      title="Drag files here or"></image-attach>
      </div>
    </div>
    <div class="sendConversationMessage__acceptable row m-0 pt-4">
      <div class="col-md-12 p-0" style="display: flex; align-items: center">
        <div style="display: inline-block">
          <div style="padding: 2px" [style.border]="!hideRequirement ? '1px solid red' : ''">
            <re-captcha (resolved)="captchaResolved($event)" *ngIf="captchaEnabled && this.captchaAvailable()"
                        [siteKey]="this.service.captchaService.getCurrentCaptchaKey()"> </re-captcha>
          </div>
        </div>

        <!-- <div style="display: inline-block;" class="ml-3">
          <div style="padding: 5px" [style.border]="!agreeTermsAndConditin && !hideRequirement ? '1px solid red' : ''">
            <mat-checkbox class="termsAgreementCheckbox" (change)="agreeTermsAndConditinChange($event)" [(ngModel)]="agreeTermsAndConditin">
              I Agree to <a href="/b/terms-of-use" target="_blank" style="text-decoration: underline">Terms And Conditions</a>
            </mat-checkbox>
          </div>
        </div> -->

        <div class="sendConversationMessage__termsWrap" *ngIf="acceptTermsEnable">
          <mat-checkbox type="checkbox" id="scales" name="terms" required (change)="onCheckChange($event)"></mat-checkbox>
          <div for="terms"><a href="https://wickedlist.com/b/terms-of-use/" target="_blank">I Agree To Terms and Conditions</a></div>
        </div>

        <div class="ml-auto">
          <button (click)="fireSubmitEvent($event)" class="submit-button p-2 pl-4 pr-4"
                  [disabled]="submitInProgress"
                  mat-flat-button color="primary" type="submit">
            {{this.submitInProgress ? 'Submitting' : 'Send Message'}}
          </button>
        </div>
      </div>
    </div>

  </form>
  <!--</image-drag-drop>-->
</div>
